var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosePf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "425EB569-7799-495F-81B3-EB9FD4574CB3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "18.-settings",
    transform: "translate(-320.000000, -36.000000)",
    stroke: "#7f3da5",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(28.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-6",
    transform: "translate(281.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(12.500000, 10.222222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.08333333,-1.30555556 L5.91666667,12.8611111",
    id: "Line-2-Copy-3",
    transform: "translate(5.500000, 5.777778) rotate(-225.000000) translate(-5.500000, -5.777778) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91666667,-1.30555556 L5.08333333,12.8611111",
    id: "Line-2-Copy-3",
    transform: "translate(5.500000, 5.777778) rotate(-135.000000) translate(-5.500000, -5.777778) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePf);
export default __webpack_public_path__ + "static/media/closePF.5c2ef7ae5c4fd6725057950c503036a0.svg";
export { ForwardRef as ReactComponent };